import type { Block } from 'src/__generated__/graphqlTypes';
import { NormalizedNcOffer } from 'src/shared/lib/offers/offersTypes';

import { BlockType } from '../config/constants';
import { AllowedBlocks } from '../config/declarations';

export const useDynamicOrDefaultBlock = (
  defaultBlock?: Block,
  dynamicBlock?: Block,
  allowedBlocks: Array<AllowedBlocks> = [],
  dynamicData: NormalizedNcOffer | null = null,
) => {
  const hasDynamicData = dynamicData && Object.keys(dynamicData).length > 0;

  if (!dynamicBlock || !allowedBlocks.includes(BlockType.DYNAMIC) || !hasDynamicData) {
    return defaultBlock;
  }

  return dynamicBlock;
};
